import { Modal } from 'bootstrap';

((oldModel) => {
  function updateModelField(makeInput, savedModels) {
    const modelInput = makeInput.parentElement.getElementsByClassName('model-select')[0];
    if (typeof modelInput === 'undefined') {
      return;
    }
    const selectedMakeId = makeInput.value;
    const DEFAULT_MAKE_MODEL = 0;
    const { defaultModel } = modelInput.dataset;
    const defaultOption = document.createElement('option');
    while (modelInput.childNodes.length > 1) {
      modelInput.lastChild.remove();
    }
    defaultOption.setAttribute('value', DEFAULT_MAKE_MODEL);
    defaultOption.append(defaultModel);

    if (selectedMakeId === '') {
      return;
    }

    if (selectedMakeId !== DEFAULT_MAKE_MODEL) {
      // eslint-disable-next-line no-restricted-syntax
      for (const model of Object.keys(savedModels[selectedMakeId].models)) {
        const modelinfo = savedModels[selectedMakeId].models[model];
        const option = document.createElement('option');
        option.setAttribute('value', modelinfo.modelId);
        option.append(modelinfo.modelName);
        modelInput.append(option);
      }
    }

    modelInput.append(defaultOption);
  }

  function compare(a, b) {
    return typeof a.makeName === 'string' && typeof b.makeName === 'string'
      ? a.makeName.localeCompare(b.makeName, undefined, { sensitivity: 'accent' })
      : a.makeName === b.makeName;
  }

  function addMakeUpdateListener(makeInput, savedModels) {
    makeInput.addEventListener('change', () => {
      updateModelField(makeInput, savedModels);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const makeInputs = document.getElementsByClassName('brand-select');
    const registerBox = document.getElementById('manual-register-form');
    let vehicleType = null;
    let savedModels = null;

    // Check if registerBox is active on current page.
    if (registerBox === null) {
      return;
    }

    // Get vehicle type.
    vehicleType = registerBox.dataset.vehicleType;

    fetch(`/models.json?vehicle-type=${vehicleType}`)
      .then((response) => response.json())
      .then((data) => {
        savedModels = data;

        const sortedMakes = Object.values(data).sort(compare);

        // fill up makes/brands
        let lastChar = '';
        let html = '';
        sortedMakes.forEach((value) => {
          const firstChar = value.makeName.toUpperCase().charAt(0);
          if (lastChar !== firstChar) {
            if (html === '') {
              html = `<optgroup label='${firstChar}'>`;
            } else {
              html += '</optgroup>';
              html += `<optgroup label='${firstChar}'>`;
            }
          }

          if (value.makeId === document.getElementById('brand').dataset.value) {
            html += `<option value='${value.makeId}' selected>${value.makeName}</option>`;
          } else {
            html += `<option value='${value.makeId}'>${value.makeName}</option>`;
          }

          lastChar = firstChar;
        });

        html += '</optgroup>';
        for (let i = 0; i < makeInputs.length; i += 1) {
          const makeInput = makeInputs[i];
          makeInput.innerHTML += html;
          addMakeUpdateListener(makeInput, savedModels);
          // Check if oldInput is set.
          if (makeInput != null) {
            const selectedMake = makeInput.value;
            if (selectedMake != null && selectedMake.length > 0 && selectedMake !== '') {
              updateModelField(makeInput, savedModels);
              if (typeof oldModel !== 'undefined' && oldModel.length > 0) {
                makeInput.parentElement.getElementsByClassName('model-select')[0].value = oldModel;
              }
            }
          }
        }
      });
  });
// eslint-disable-next-line camelcase, no-undef
})((typeof old_model !== 'undefined' && old_model));

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('vwe-error') !== null) {
    const myModal = new Modal(document.getElementById('vwe-error'));
    myModal.show();
  }
});
